import React from 'react';
import { Box, styled, Theme } from '@mui/material';

// The outer wrapper that creates the gradient border effect.
const GradientBorderWrapper = styled(Box)(({ theme }: { theme: Theme }) => ({
  // The padding defines the thickness of the border.
  padding: '2px', 
  borderRadius: '10px', // The outer radius for the border.
  border: 'none',


  backgroundOrigin: 'border-box',
  backgroundClip: 'padding-box, border-box',
  backgroundImage: `
    linear-gradient(91deg, #2563EB 5.84%, #7C3AED 94.16%), 
    linear-gradient(180deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})
  `,
}));

export const GradientBorder = ({ children }: { children: React.ReactNode }) => {
  return (
    <GradientBorderWrapper>
      <Box sx={{ bgcolor: 'background.paper', borderRadius: '10px', height: '100%' }}>
        {children}
      </Box>
    </GradientBorderWrapper>
  );
};